/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {EdisonServerDataParser} from "../EdisonServerDataParser";
import {IEdisonGameData} from "./IEdisonServerData";
import { IBetWayWinData, IServerData } from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import { EdisonGameMode } from "../../gameMode/EdisonGameMode";


export interface EdisonIBetWayWinData extends IBetWayWinData{
    amount:number,
    length:number,
    mode:string,
    multipliedAmount:number,
    multiplier:number,
    numberOfCombinations:number,
    reelWinPositions:boolean[][],
    symbol:string,
}

export class EdisonParsedGameData extends SpinParsedGameData {

    private _betWayWins:EdisonIBetWayWinData[] | undefined;
    private _stackedWildModeTriggeredThisSpin:boolean;
    private _randomWildModeTriggeredThisSpin:boolean;
    private _randomM1WildModeTriggeredThisSpin:boolean;
    private _randomM2WildModeTriggeredThisSpin:boolean;
    private _evaluatedArea:string[][];
    private _symbolsCollectedBefore:number[];
    private _symbolsCollectedAfter:number[];
    private _meterFSReset:boolean[];
    private _stackedModeOverlay:boolean[];
    private _stackedNearWinReels:boolean[];
    private _fsMeterMaxAfterReelIndex:number[];
    private _freespinsLeftBefore:number;
    private _fsMeterAfterEachReel:number[][];
    public betWaysOriginalData:IBetWayWinData[];

    constructor(rawData:IEdisonGameData, dataParser:EdisonServerDataParser) {
        super(rawData, dataParser);

        this._betWayWins = dataParser.parseBetWayWins(rawData);
        this._stackedWildModeTriggeredThisSpin = dataParser.parseStackedWildModeTriggeredThisSpin(rawData);
        this._randomWildModeTriggeredThisSpin = dataParser.parseRandomWildModeTriggeredThisSpin(rawData);
        this._randomM1WildModeTriggeredThisSpin = dataParser.parseRandomM1WildModeTriggeredThisSpin(rawData);
        this._randomM2WildModeTriggeredThisSpin = dataParser.parseRandomM2WildModeTriggeredThisSpin(rawData);
        this._evaluatedArea = dataParser.parseEvaluatedArea(rawData);
        this._symbolsCollectedBefore = dataParser.parseSymbolsCollectedBefore(rawData);
        this._symbolsCollectedAfter = dataParser.parseSymbolsCollectedAfter(rawData);
        this._meterFSReset = dataParser.parseMeterFSReset(rawData);
        this._stackedModeOverlay = dataParser.parseStackedModeOverlay(rawData);
        this._stackedNearWinReels = dataParser.parseStackedNearWinReels(rawData);
        this._freespinsLeftBefore = dataParser.parseFreespinsLeftBefore(rawData);
        this._fsMeterMaxAfterReelIndex = dataParser.parseFsMeterMaxAfterReelIndex(rawData);
        this._fsMeterAfterEachReel = dataParser.parseFsMeterAfterEachReel(rawData);
        this.betWaysOriginalData=JSON.parse(JSON.stringify(rawData.betWayWins));
    }

    public get betWayWins():EdisonIBetWayWinData[] | undefined{
        return this._betWayWins;
    }

    public get stackedWildModeTriggeredThisSpin():boolean {
        return this._stackedWildModeTriggeredThisSpin;
    }

    public get randomWildModeTriggeredThisSpin():boolean {
        return this._randomWildModeTriggeredThisSpin;
    }

    public get randomM1WildModeTriggeredThisSpin():boolean {
        return this._randomM1WildModeTriggeredThisSpin;
    }

    public get randomM2WildModeTriggeredThisSpin():boolean {
        return this._randomM2WildModeTriggeredThisSpin;
    }

    public get evaluatedArea():string[][] {
        return this._evaluatedArea;
    }

    public get symbolsCollectedBefore():number[] {
        return this._symbolsCollectedBefore;
    }

    public get symbolsCollectedAfter():number[] {
        return this._symbolsCollectedAfter;
    }

    public get meterFSReset():boolean[] {
        return this._meterFSReset;
    }

    public get stackedNearWinReels():boolean[] {
        return this._stackedNearWinReels;
    }


    public get stackedModeOverlay():boolean[] {
        return this._stackedModeOverlay;
    }

    public get freespinsLeftBefore():number {
        return this._freespinsLeftBefore;
    }
    public get fsMeterMaxAfterReelIndex():number[] {
        return this._fsMeterMaxAfterReelIndex;
    }

    public get fsMeterAfterEachReel():number[][] {
        return this._fsMeterAfterEachReel;
    }

    protected isRespin(rawData:IServerData):boolean {
        return this.mode === EdisonGameMode.STACKED_RESPIN;
    }

    protected isNextRespin(rawData:IServerData):boolean {
        return this.nextMode === EdisonGameMode.STACKED_RESPIN;
    }
}